import { push } from '@/common/utils';
import configurationsApi from '@/api/configurationsApi';
import commonMixing from '@/mixins/common';
import axios from 'axios';

const state = {
  modules: [], //non-reactive modules configurations
  moduleConfigsByModuleType: {}, // öV-Pad module configurations
  moduleConfigsByModuleTypeAndInstance: {}, // key=moduleType_instance
  // non-reactive states
  defaultLanguage: null,
  stage: null,
  languageKeys: [],
  homeScreen: [],
  customerFeatures: {},
  features: {},
  bottomNavigation: [],
  publicVapidKey: null,
  user: {}, // additional user information such as userId (not stored in localStorage)
};

const getters = {
  getInstanceModuleConfig:
    (state) =>
    ({ moduleType, instance }) => {
      let moduleTypeAndInstance;
      if (instance) {
        moduleTypeAndInstance = `${moduleType}_${instance}`;
      } else {
        moduleTypeAndInstance = `${moduleType}`;
      }

      return state.moduleConfigsByModuleTypeAndInstance[moduleTypeAndInstance];
    },
  getModuleConfig:
    (state) =>
    ({ moduleType, instance }) => {
      let modulesOfType = state.moduleConfigsByModuleType[moduleType];
      let moduleConfig;
      if (modulesOfType) {
        if (instance) {
          // moduleConfig = modulesOfType.filter((module) => module.instance === instance)[0];
          moduleConfig = modulesOfType.find((module) => module.instance === instance);
          if (!moduleConfig) {
            console.log('Failure getting moduleConfig of type', moduleType, 'and instance', instance, state.moduleConfigsByModuleType);
          }
        } else {
          moduleConfig = modulesOfType[0];
          if (!moduleConfig) {
            console.log('Failure getting moduleConfig of type', moduleType, state.moduleConfigsByModuleType);
          }
        }
      }
      return moduleConfig;
    },
};

const mutations = {
  storePreAuthConfig(state, { preAuthConfig }) {
    console.debug('storePreAuthConfig', preAuthConfig, 'localStorage.getItem(lang)', localStorage.getItem('lang'));
    let { customerFeatures, languageKeys, defaultLanguage } = preAuthConfig;

    state.languageKeys = Object.freeze(languageKeys);
    state.defaultLanguage = defaultLanguage;

    // set the lang in localStorage in case it is not present
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', defaultLanguage);
    }

    state.customerFeatures = customerFeatures;
    state.features = customerFeatures;
    state.stage = preAuthConfig.stage;
  },

  storeAuthenticatedConfig(state, { authenticatedConfig }) {
    let { features, bottomNavigation, modules, homeScreen, user, defaultLanguage, languageKeys } = authenticatedConfig;
    state.features = { ...Object.freeze(features), ...state.features };
    state.bottomNavigation = bottomNavigation;
    state.modules = modules;
    state.languageKeys = Object.freeze(languageKeys);
    state.defaultLanguage = Object.freeze(defaultLanguage);

    // set the lang in localStorage in case it is not present
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', defaultLanguage);
    }
    state.homeScreen = homeScreen;
    state.publicVapidKey = Object.freeze(authenticatedConfig.publicVapidKey);
    state.user = Object.freeze(user);

    let moduleTypes = {};
    let moduleConfigsByModuleType = {};
    let moduleConfigsByModuleTypeAndInstance = {};

    modules.forEach((module) => {
      module.quickLink = false;
      let moduleType = module.type;
      let moduleTypeAndInstance = moduleType + (module.instance ? `_${module.instance}` : '');
      moduleConfigsByModuleTypeAndInstance[moduleTypeAndInstance] = module;
      push(moduleConfigsByModuleType, moduleType, module);
      moduleTypes[moduleType] = { hasInstance: module.instance !== undefined };

      // cache module image
      if (module.imgIcon) {
        let url = commonMixing.methods.assetUrl(module.imgIcon);

        axios.get(url).catch((err) => {
          console.warn('failed to load url', url, err);
        });
      }
    });

    state.moduleConfigsByModuleType = Object.freeze(moduleConfigsByModuleType);
    state.moduleConfigsByModuleTypeAndInstance = Object.freeze(moduleConfigsByModuleTypeAndInstance);
    state.moduleTypes = Object.freeze(moduleTypes);

    const stage = authenticatedConfig.stage;
    state.stage = stage;

    const browserTitle = authenticatedConfig.customerFeatures.browserTitle;

    if (browserTitle) {
      document.title = `${browserTitle} ${stage !== 'prod' ? stage.toUpperCase() : ''}`;
    }
  },
};
const ROOT = { root: true };
const actions = {
  /**
   * Loads all necessary configuration data as soon the user is authenticated. Configuration includes the ui-config and the language file
   * @param commit
   * @param dispatch
   * @returns {Promise<void>}
   */
  async loadConfigurations({ commit, dispatch }) {
    console.log("ACTION 'loadConfigurations' loads ui-config and dispatches it's values to the appropriate stores");

    try {
      const lang = (localStorage.getItem('locale') || 'de-DE').substring(0, 2);
      await dispatch('language/loadLanguage', { lang }, ROOT);
      const authenticatedConfigResponse = await configurationsApi.loadAuthenticatedUiConfig();
      const authenticatedConfig = authenticatedConfigResponse.data;
      const userId = authenticatedConfig && authenticatedConfig.user ? authenticatedConfig.user.userId : 'not defined';

      dispatch('profile/setUserId', userId, ROOT);
      const { customerRelation } = authenticatedConfig;
      commit('configs/storeAuthenticatedConfig', { authenticatedConfig }, ROOT);

      let { timeFormat } = authenticatedConfig.features;
      let tenantUserProfileDefaults = { timeFormat };
      commit('profile/initUserProfile', tenantUserProfileDefaults, ROOT);

      commit('profile/setCustomerRelations', { customerRelations: customerRelation }, ROOT);
    } catch (err) {
      console.error('Failed to load configurations', err);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
